import { render, staticRenderFns } from "./Psd2SkippedInfo.vue?vue&type=template&id=6f4b12db&scoped=true&"
import script from "./Psd2SkippedInfo.vue?vue&type=script&lang=js&"
export * from "./Psd2SkippedInfo.vue?vue&type=script&lang=js&"
import style0 from "./Psd2SkippedInfo.vue?vue&type=style&index=0&id=6f4b12db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4b12db",
  null
  
)

export default component.exports